// src/components/app/auth/AdminProtectedRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../../../context/AdminAuthContext";

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

const LoadingSpinner: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
      <p className="text-gray-600">Verificando acceso de administrador...</p>
    </div>
  </div>
);

export const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { adminData, loading } = useAdminAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!adminData) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
};

export const AdminRedirect: React.FC = () => {
  const { adminData, loading } = useAdminAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (adminData) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <Navigate to="/admin/login" replace />;
};

interface PublicAdminRouteProps {
    children: React.ReactNode;
}

export const PublicAdminRoute: React.FC<PublicAdminRouteProps> = ({ children }) => {
    const { adminData, loading } = useAdminAuth();

    if (loading) {
        return <LoadingSpinner />;
    }

    if (adminData) {
        return <Navigate to="/admin/dashboard" replace />;
    }

    return <>{children}</>;
};